// AUTO-GENERATED by tools/generate.mjs - do not edit by hand.
// Source: tools/sections.spec.mjs
import type { ComponentType } from 'react';
import type { PageSection, SectionType } from '../types/sections';
import PageIntro from './custom/PageIntro';
import HeroMedia from './custom/HeroMedia';
import SplitContentMedia from './custom/SplitContentMedia';
import MediaFeature from './custom/MediaFeature';
import FeatureCards from './custom/FeatureCards';
import PhotoHighlights from './custom/PhotoHighlights';
import ServiceList from './custom/ServiceList';
import Pillars from './custom/Pillars';
import Stats from './custom/Stats';
import Checklist from './custom/Checklist';
import Accordion from './custom/Accordion';
import Timeline from './custom/Timeline';
import Quote from './custom/Quote';
import TextSlider from './custom/TextSlider';
import HighlightPanelList from './custom/HighlightPanelList';
import ToolsShowcase from './custom/ToolsShowcase';
import PlatformList from './custom/PlatformList';
import ProductPreview from './custom/ProductPreview';
import ProductShowcase from './custom/ProductShowcase';
import FeatureColumns from './custom/FeatureColumns';
import PromoBanner from './custom/PromoBanner';
import TextPanel from './custom/TextPanel';
import MeetingsGrid from './custom/MeetingsGrid';
import TeamTeaser from './custom/TeamTeaser';
import FlipCards from './custom/FlipCards';
import BenefitsGrid from './custom/BenefitsGrid';
import HistoryTeaser from './custom/HistoryTeaser';
import ManagementGrid from './custom/ManagementGrid';
import NewsTeaser from './custom/NewsTeaser';
import ArticleGrid from './custom/ArticleGrid';
import ArticleBody from './custom/ArticleBody';
import CountryList from './custom/CountryList';
import VisaFeature from './custom/VisaFeature';
import LegalList from './custom/LegalList';
import ContactForm from './custom/ContactForm';
import DownloadList from './custom/DownloadList';
import ContactCard from './custom/ContactCard';

// Every renderer receives the whole section object; the registry is intentionally
// loose about the exact member type so that adding a section never breaks the map.
export type SectionComponent = ComponentType<{ data: never }>;

export const sectionRegistry: Record<SectionType, SectionComponent> = {
  pageIntro: PageIntro as SectionComponent,
  heroMedia: HeroMedia as SectionComponent,
  splitContentMedia: SplitContentMedia as SectionComponent,
  mediaFeature: MediaFeature as SectionComponent,
  featureCards: FeatureCards as SectionComponent,
  photoHighlights: PhotoHighlights as SectionComponent,
  serviceList: ServiceList as SectionComponent,
  pillars: Pillars as SectionComponent,
  stats: Stats as SectionComponent,
  checklist: Checklist as SectionComponent,
  accordion: Accordion as SectionComponent,
  timeline: Timeline as SectionComponent,
  quote: Quote as SectionComponent,
  textSlider: TextSlider as SectionComponent,
  highlightPanelList: HighlightPanelList as SectionComponent,
  toolsShowcase: ToolsShowcase as SectionComponent,
  platformList: PlatformList as SectionComponent,
  productPreview: ProductPreview as SectionComponent,
  productShowcase: ProductShowcase as SectionComponent,
  featureColumns: FeatureColumns as SectionComponent,
  promoBanner: PromoBanner as SectionComponent,
  textPanel: TextPanel as SectionComponent,
  meetingsGrid: MeetingsGrid as SectionComponent,
  teamTeaser: TeamTeaser as SectionComponent,
  flipCards: FlipCards as SectionComponent,
  benefitsGrid: BenefitsGrid as SectionComponent,
  historyTeaser: HistoryTeaser as SectionComponent,
  managementGrid: ManagementGrid as SectionComponent,
  newsTeaser: NewsTeaser as SectionComponent,
  articleGrid: ArticleGrid as SectionComponent,
  articleBody: ArticleBody as SectionComponent,
  countryList: CountryList as SectionComponent,
  visaFeature: VisaFeature as SectionComponent,
  legalList: LegalList as SectionComponent,
  contactForm: ContactForm as SectionComponent,
  downloadList: DownloadList as SectionComponent,
  contactCard: ContactCard as SectionComponent,
};

/** Sections whose React component is still generated boilerplate, not designed. */
export const generatedSections: SectionType[] = [

];

export function getSectionComponent(type: string): SectionComponent | null {
  return (sectionRegistry as Record<string, SectionComponent>)[type] ?? null;
}

export type { PageSection };
